export const DEFAULT_SETTINGS = {
  myColors: [],
  welcomeBannerSeen: false,
  isLiked: false,
  isQuickMenuShown: false,
  tips: {
    version: 0
  },
  favorites: {
    fonts: []
  },
  preferences: {
    autoConfirmSwapVideo: false
  }
}
export function upgrade() {}